import React,{useState} from 'react'
import InvoicePDF from './InvoicePDF';
import InputForm from './InputForm';
import signatureImage from '../sign.jpg';

const Invoice = () => {
  const [invoiceData, setInvoiceData] = useState({
    sellerDetails:{
        name:"cQube",
        "address": {
            "addressLine1": "shop #3 ground floor ",
            "city": "Bengaluru",
            "state": "Karnataka",
            "pincode": "560002",
            "countryAbbr": "IN"
        },
        pan:" ",
        gstRegistrationNo:"",
    },
    billingDetails:{
        name:" ",
        address:{
            addressLine1:" ",
            addressLine2:" ",
            city:"Bengaluru",
            state:"Karnataka",
            pincode:"560037",
            countryAbbr:"IN",
            utCode:"29"
        },
    },
    shippingDetails:{
        name:" ",
        address:{
            addressLine1:" ",
            addressLine2:" ",
            city:"Bengaluru",
            state:"Karnataka",
            pincode:"560037",
            countryAbbr:"IN",
            utCode:"29"
        },
    },
    placeOfDelivery:"Karnataka",
    placeOfSupply:"Karnataka",
    orderSummary:{
        orderNo:"403-3258454-3258454",
        orderDate:"28.10.2019"
    },
    invoiceSummary:{
        invoiceNo:"IN-2754",
        invoiceDetails:"KA-4514531512-1920",
        invoiceDate:"28.10.2019",
    },
    reverseCharge:"No",
    itemList:[
        {
            description:"Varasiddhi Silks Men's Formal Shirt (SH-06-42, Navy Blue,42) | B07KGF3KW8 (SH-05--42)",
            unitPrice:"538.10",
            quantity:"1",
            // discount:"",
            taxRate:"5"
        },
        {
            description:"Varasiddhi Silks Men's Formal Shirt (SH-06-42, Navy Blue,42) | B07KGF3KW8 (SH-05--42)",
            unitPrice:"538.10",
            quantity:"1",
            // discount:"",
            taxRate:"5"
        }
    ],
    signatureImage:signatureImage
  });
  const [fillForm,setFillForm] = useState(true);

  const handleMainFormData = ((data)=>{
    setInvoiceData(data);
    setFillForm(false);
  });

  return (
    <>
        {fillForm?
        <InputForm handleMainFormData={handleMainFormData}  />:
        <InvoicePDF invoiceData={invoiceData} setFillForm={setFillForm} />
        }
        
    </>
  )
}
export default Invoice;